import { config } from 'config/config';
import { IUser } from 'src/shared/models';

export const isValidZipCode = (value: string) => {
  return value && value.length === config.REGISTER.ZIPCODE_LENGTH;
};

export const getEmailFromQuery = (email: string | string[]) => {
  if (!email) return '';
  if (typeof email === 'string') return email;
  return email[0];
};

export const minAgeDate = (age: number) => {
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - age);

  return minDate.toISOString().slice(0, 10);
};
export const passwordIsNotNameOrEmail = (form) => {
  const { name, password, email } = form;
  const emailUser: string = email.split('@')[0];

  if (!password) return false;

  return (
    !password.toLowerCase()?.includes(name.toLowerCase()) &&
    !name.toLowerCase()?.includes(password.toLowerCase()) &&
    !password.toLowerCase()?.includes(emailUser.toLowerCase()) &&
    !emailUser.toLowerCase()?.includes(password.toLowerCase())
  );
};

export const getPrefixPhone = (
  user: IUser,
  prefix: string
): { prefix: string; phone: string } => {
  let phone =
    user?.salesforce?.userPhone || user?.temporalData?.telephone || '';

  if (phone) {
    if (phone.split('-')[1] !== undefined) {
      if (phone.split('-')[0] !== null) {
        prefix = phone.split('-')[0];
      }
      phone = phone.split('-')[1];
    } else {
      phone = phone.split('-')[0];
    }
  }

  return { prefix, phone };
};
